import { createStore } from "vuex";
import publisher from "@/store/modules/publisher";
import geolocation from "@/store/modules/geolocation";
import search from "@/store/modules/search";
import vehicleMakeModels from "@/store/modules/vehicleMakeModels";
import chat from "@/store/modules/chat";

const store = createStore({
  strict: false,
  state: {
    brand: {
      name: "CarScience",
      domain: "carscience.com",
      contactEmail: "support@carscience.com"
    },
    appLoading: false,
    sessionId: Math.floor(Math.random() * 10000).toString()
  },
  getters: {
    returningVisitor: state => {
      return window.localStorage.getItem("last-carscience-session-id") !== null && state.sessionId != window.localStorage.getItem("last-carscience-session-id");
    },
  },
  mutations: {},
  actions: {},
  modules: {
    publisher,
    geolocation,
    search,
    vehicleMakeModels,
    chat
  },
  plugins: [
    // Initialize search module with store instance
    store => {
      if (search.plugin) {
        search.plugin(store);
      }
    }
  ]
});

export default store;
